import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import CategoriesDropdownMobile from '../CategoriesDropdown/CategoriesDropdownMobile';
import BrandsDropdownMobile from '../BrandsDropdown/BrandsDropdownMobile';

interface MobileMenuPopProps{
    isOpen : boolean;
    setIsOpen : (isOpen : boolean) => void;
}
const MobileMenuPop = ({isOpen,setIsOpen} : MobileMenuPopProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Search Query:', searchQuery); // Replace with your search logic
  };

  return (
    <>
       {isOpen && <div className='mobile-menu-pop'>
           <CategoriesDropdownMobile setIsOpen={setIsOpen}/>
           <BrandsDropdownMobile setIsOpen={setIsOpen} />
        </div>}
    </>
  );
};

export default MobileMenuPop;